import React from 'react';

import ProductCategoryEdit from '@shared/product_categories/ProductCategoryEdit';

import productCategoryService from '@services/operator/productCategoryService';

export default function OperatorProductCategoryNew() {
  return (
    <ProductCategoryEdit
      productCategoryService={productCategoryService}
      role="operator"
    />
  );
}
